import VBaseTrackContextProvider from './VBaseTrackContextProvider';
import { TRACK_TYPE } from './constant';
import type { VBaseTrackProps, VBaseTrackType } from './type';

const VBaseTrack = <T extends VBaseTrackType = TRACK_TYPE.NORMAL>({
  children,
  type = TRACK_TYPE.NORMAL as T,
  ...rest
}: React.PropsWithChildren<VBaseTrackProps<T>>) => {
  if (rest.step != null && rest.step <= 0) {
    throw new Error('`step` must be > 0');
  }

  if (rest.min === rest.max) {
    throw new Error('`min` and `max` must be different');
  }

  if (rest.max != null && rest.min != null && rest.min > rest.max) {
    throw new Error('`min` shall be less than `max`');
  }

  return (
    <VBaseTrackContextProvider type={type} {...rest}>
      {children}
    </VBaseTrackContextProvider>
  );
};

export default VBaseTrack;
